/**
 * Centralized Nakshatra Chakra default settings
 * Single source of truth for nakshatra visibility defaults
 */

import { getLocalStorageItem } from '../utils/localStorageUtils';
import { FONTS } from './fonts';

/**
 * Get default nakshatra chakra visibility setting
 * @returns boolean - true by default (always visible including guest mode)
 */
export const getDefaultNakshatraChakraVisibility = (): boolean => {
    return true;
};

/**
 * Get nakshatra chakra setting from localStorage with fallback
 * @param chartId - chart identifier
 * @returns boolean - saved setting or default
 */
export const getNakshatraChakraSettingForChart = (chartId: string): boolean => {
    const settings = getLocalStorageItem<Record<string, any> | null>(`chart-settings-${chartId}`, null);
    return settings?.showNakshatraChakra ?? getDefaultNakshatraChakraVisibility();
};

/**
 * Nakshatra Pada Division Styling Configuration
 * Centralized styles for pada subdivision rendering (108 padas = 27 nakshatras × 4)
 */
export const NAKSHATRA_PADA_CONFIG = {
    // Стили линий пада (4 линии на каждую накшатру, включая границу)
    padaDivisionLine: {
        stroke: '#FF6B35',           // Яркий оранжевый (для теста - хорошо видно!)
        strokeWidth: 0.6,            // Толщина линии
        strokeDasharray: '1 2',         // Сплошная линия (для теста)
        strokeOpacity: 0.6,          // Прозрачность
        length: 100                   // Длина от центра к внешнему краю (увеличено x2)
    },

    // Стили номеров пада (1-4 внутри каждой накшатры)
    padaNumberStyle: {
        fontFamily: FONTS.chart.primary,
        fontSize: 8,                // Крупнее для видимости
        fontWeight: '400',           // Жирнее
        fill: '#2c2c2c',             // Красный (для теста - хорошо видно!)
        stroke: '#FFFFFF',
        strokeWidth: 0,
        opacity: 1.0                 // Полностью непрозрачный
    },

    // Позиционирование номеров (offset от внешнего края сектора)
    padaNumberOffset: 90          // 20px от outer edge
};

/**
 * Get default nakshatra pada visibility setting
 * @returns boolean - false by default (hidden on page load)
 */
export const getDefaultNakshatraPadaVisibility = (): boolean => {
    return false;
};

/**
 * Get nakshatra pada setting from localStorage with fallback
 * @param chartId - chart identifier
 * @returns boolean - saved setting or default
 */
export const getNakshatraPadaSettingForChart = (chartId: string): boolean => {
    const settings = getLocalStorageItem<Record<string, any> | null>(`chart-settings-${chartId}`, null);
    return settings?.showNakshatraPada ?? getDefaultNakshatraPadaVisibility();
};